<template>
    <div>
        <form @submit.prevent="submitFormData">
            <div class="row">
                <div class="col-sm-12 col-md-6 border-right p-3">
                    <h5 class="pb-2 border-bottom text-primary">
                        <i class="fal fa-info-circle mr-1"></i>
                        {{$t('branding.header_general')}}
                    </h5>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.title')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-text"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="name" required="">
                        </div>
                    </div>
                    <div v-if="!isEdit" class="form-group">
                        <label class="form-label">{{$t('tukang.stylist')}}</label>
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0 bg-transparent">
                                    <i class="fas fa-user"></i>
                                </label>
                                <multiselect  
                                    v-model="selectedStaff" 
                                    :options="staffs" 
                                    track-by="TkStylistID" label="TkStylistName" 
                                    :show-labels="false" 
                                    openDirection="below" 
                                    @select="selectStaff">
                                    <span slot="noResult">{{$t('table.no_records')}}</span>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div v-else class="form-group">
                        <label class="form-label">{{$t('tukang.stylist')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text  border-right-0">
                                    <i class="fas fa-user"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control pl-3" disabled v-model="stylistName">
                            <input type="hidden"  v-model="stylistID">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('table.header.type')}}</label>
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0 bg-transparent">
                                    <i class="fas fa-folder"></i>
                                </label>
                                <multiselect  
                                    v-model="selectedPostType" 
                                    :options="postType" 
                                    group-values="type" group-label="category" 
                                    track-by="id" label="text" 
                                    :show-labels="false" 
                                    openDirection="below" 
                                    @select="selectType">
                                    <span slot="noResult">{{$t('table.no_records')}}</span>
                                    <template slot="singleLabel" slot-scope="props">
                                        <span class="badge badge-primary pl-2 pr-2 pt-1 pb-1">{{ props.option.text}}</span>
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                            <label class="form-label">{{$t('label.item_type')}}</label>
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0 bg-transparent">
                                        <i class="fas fa-list"></i>
                                    </label>
                                    <multiselect  
                                        v-model="selectedItemType" 
                                        :options="itemType" 
                                        track-by="id" label="text" 
                                        :show-labels="false" 
                                        openDirection="below" 
                                        @select="selectItemType">
                                        <span slot="noResult">{{$t('table.no_records')}}</span>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.duration')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-clock"></i>
                                </span>
                            </div>
                            <vue-timepicker class="form-control bg-transparent" 
                                :format="'H hr mm Min'" 
                                :hide-disabled-hours="true" 
                                :hour-range="hourRange" 
                                :minute-range="minRange" 
                                :minute-interval="15" 
                                v-model="duration" 
                                @change="setTimePicker"
                                @input="inputTimePicker"></vue-timepicker>
                        </div>
                        <div id="err" class="error-validation"></div>
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="requiredAddress" v-model="requiredAddress">
                            <label class="custom-control-label" for="requiredAddress">{{$t('label.required_address')}}</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.url', {'item': $t('header.post')})}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-at"></i>
                                </span>
                            </div>
                            <div class="input-group-prepend">
                                <span class="input-group-text pl-1 pr-1">{{$api.URL_TUKANG}}{{shopName}}/</span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-1" :placeholder="$t('label.url', {'item': $t('header.post')})" @keydown.space="(event) => event.preventDefault()" v-model="postURL">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.details')}}</label>
                        <textarea class="form-control" :placeholder="$t('label.details')" rows="5" v-model="details"></textarea>
                    </div>
                    <h5 class="pb-2 border-bottom text-primary">
                        <i class="fal fa-usd-circle mr-1"></i>
                        {{$t('table.header.price') + $t('brand_submenu.brand_setup_configuration')}}
                    </h5>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.currency')}}</label>
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0 bg-transparent">
                                    <i class="fas fa-badge-dollar"></i>
                                </label>
                                <multiselect v-model="selectedCurrency" :placeholder="$t('label.currency')" label="text" track-by="id" :options="currency" :option-height="104" :show-labels="false" @select="selectCurrency">
                                    <template slot="singleLabel" slot-scope="props">
                                        <flag :iso="props.option.flag" class="mr-2"/>
                                        <span class="option__desc"><span class="option__title">{{ props.option.text }}</span></span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div class="option__desc">
                                            <flag :iso="props.option.flag" class="mr-2"/>
                                            <span class="option__desc"><span class="option__title">{{ props.option.text }}</span></span>
                                        </div>
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.price')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.price')" @keypress="isNumber($event)" @keyup="priceValidation('price')" v-model="price"  required="">
                                </div>
                                <div id="errprice" class="error-validation"></div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">{{$t('subMenu.salon_menu_discount')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('subMenu.salon_menu_discount')" @keypress="isNumber($event)" @keyup="priceValidation('discount')" v-model="discount" required="">
                                </div>
                                <div id="errdiscount" class="error-validation"></div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.discount_code')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-ticket-alt"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" minlength="4" :placeholder="$t('label.discount_code')" v-model="discountCode">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.discount_amount')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.discount_amount')" @keypress="isNumber($event)" @keyup="priceValidation('discount_amount')" v-model="discountAmount">
                                </div>
                                <div id="errdiscount_amount" class="error-validation"></div>
                            </div>
                        </div>
                        <div class=" col-sm-12 col-md-6 mb-3">
                            <label class="form-label">{{$t('table.header.tax')}}</label>
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0 bg-transparent">
                                        <i class="fas fa-hand-holding-usd"></i>
                                    </label>
                                    <multiselect  
                                        v-model="selectedTax" 
                                        :options="tax" 
                                        track-by="id" label="text" 
                                        :show-labels="false" 
                                        openDirection="below" 
                                        @select="selectTax">
                                        <span slot="noResult">{{$t('table.no_records')}}</span>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div :class="selectedTax.id != 'no' ? 'visible': 'invisible'" class=" col-sm-12 col-md-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">{{$t('outlet_setting.info.tax.amount')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('outlet_setting.info.tax.amount')" v-model="taxAmount">
                                </div>
                            </div>
                        </div>
                        <div class=" col-sm-12 col-md-6 mb-3">
                            <label class="form-label">{{$t('label.additional_charges')}} 1</label>
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0 bg-transparent">
                                        <div class='icon-stack fs-xl'>
                                            <i class="fas fa-dollar-sign icon-stack-2x opacity-100"></i>
                                            <i class="fal fa-plus icon-stack-2x opacity-100 ml-2" style="top: .5em;"></i>
                                        </div>
                                    </label>
                                    <multiselect  
                                        id="additional_1"
                                        v-model="selectedAdditionalCharges1" 
                                        :options="additionalCharges" 
                                        track-by="id" label="text" 
                                        :show-labels="false" 
                                        openDirection="below" 
                                        @select="selectAdditionalCharges">
                                        <span slot="noResult">{{$t('table.no_records')}}</span>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div :class="selectedAdditionalCharges1.id != 'no' ? 'visible': 'invisible'" class=" col-sm-12 col-md-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">{{selectedAdditionalCharges1.text}} ({{$t('label.amount')}})</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.additional_charges') + '(' + $t('label.amount') + ') 1'" v-model="additionalCharges1">
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedAdditionalCharges1.id != 'no'" class=" col-sm-12 col-md-6 mb-3">
                            <label class="form-label">{{$t('label.additional_charges')}} 2</label>
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0 bg-transparent">
                                        <div class='icon-stack fs-xl'>
                                            <i class="fas fa-dollar-sign icon-stack-2x opacity-100"></i>
                                            <i class="fal fa-plus icon-stack-2x opacity-100 ml-2" style="top: .5em;"></i>
                                        </div>
                                    </label>
                                    <multiselect  
                                        id="additional_2"
                                        v-model="selectedAdditionalCharges2" 
                                        :options="filteredAdditionalCharges" 
                                        track-by="id" label="text" 
                                        :show-labels="false" 
                                        openDirection="below" 
                                        @select="selectAdditionalCharges">
                                        <span slot="noResult">{{$t('table.no_records')}}</span>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div v-show="selectedAdditionalCharges2.id != 'no'" class=" col-sm-12 col-md-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">{{selectedAdditionalCharges2.text}} ({{$t('label.amount')}})</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.additional_charges') + '(' + $t('label.amount') + ') 2'" v-model="additionalCharges2">
                                </div>
                            </div>
                        </div>
                    </div>
                    <h5 class="mt-3 pb-2 border-bottom text-primary">
                        <i class="fal fa-user-circle mr-1"></i>
                        {{$t('header.customer_type')}}
                    </h5>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="walkin" v-model="walkin">
                                    <label class="custom-control-label" for="walkin">{{$t('label.walk_in')}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="memberOnly" v-model="memberOnly">
                                    <label class="custom-control-label" for="memberOnly">{{$t('label.member_only')}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 p-5">
                    <h5>{{$t('label.image')}}:</h5>
                    <div class="card-columns">
                        <div v-for="item in gallery" :key="item.id" class="card">
                            <div v-if="item.src != ''">
                                <div class="card-header p-2 border-bottom-0 d-flex align-items-center justify-content-end">
                                    <div class="text-primary">
                                        <a class="link mr-2" @click="showUploadImage(item)">
                                            <i class="fal fa-cog"></i>
                                        </a>
                                        <a class="link" @click="showDeleteImage(item)">
                                            <i class="fal fa-trash"></i>
                                        </a>
                                    </div>
                                </div>
                                <img class="border-top-left-radius-0 border-top-right-radius-0 card-img-top" :src="getImage(item.src)"/>
                            </div>
                            <div v-else>
                                <div class="card-header p-2 border-bottom-0 d-flex align-items-center justify-content-end" style="height: 2.5em;"></div>
                                <div class="pt-5 pb-5 card-body d-flex align-items-center justify-content-center">
                                    <a class="link" title="Add Image" @click="showUploadImage(item)">
                                        <div class='icon-stack display-3'>
                                            <i class="fas fa-image-polaroid icon-stack-3x opacity-50 color-fusion-500" ></i>
                                            <i class="fas fa-plus-circle icon-stack-1x opacity-100 color-fusion-300"></i>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="border-top text-left pt-3 mt-3 mb-3">
                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
            </div>
        </form>
        <div :class="{'show': uploadToggle }" class=" modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 d-flex align-items-center"><i class="fas fa-cloud-upload-alt mr-3"></i>{{$t('header.upload_image')}}</h5>
                        <button type="button" class="close" @click="uploadToggle = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body pt-3">
                        <div v-if="selectedImage.src != ''">
                            <h6 class="fw-500">{{$t('label.selected_image')}}: </h6>
                            <img class="img-item mb-3" :src="getImage(selectedImage.src)"/>
                        </div>
                        <vue-dropzone :id="selectedImage.id" ref="dropzone" class="text-center" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import VueTimepicker from 'vue2-timepicker'
import vueDropzone from "vue2-dropzone";
import {convertToMin, formFormatTime, formatPrice, isNumber} from './../../../../assets/js/dashboard/utilities'
import {handleSessionExpired} from '@/assets/js/dashboard/dashboard.js'
export default {
    name: "tukangStaffPostForm",
    components:{
        VueTimepicker, vueDropzone, DeleteModal
    },
    data(){
        return{
            isEdit: false,
            shopName: "",
            staffs:[], selectedStaff: {},
            stylistID: 0, stylistName: "",
            name: "", details: "",
            postURL: "",
            selectedCurrency: {},
            selectedAdditionalCharges1: {},
            selectedAdditionalCharges2:{},
            additionalCharges1: 0, 
            additionalCharges2: 0,
            selectedTax: {}, taxAmount: 0,
            postType: [], selectedPostType: {},
            selectedItemType: {},
            discountCode: "", discountAmount: 0,
            walkin: 0, memberOnly: 0, requiredAddress: 0,
            price: 0, discount: 0, duration: "", postID: 0,
            gallery: [], hourRange: [], minRange: [],
            uploadToggle: false, selectedImage: {},
            isDropzoneShow: false, 
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            }
        }
    },
    computed:{
        currency(){
            return[
                {id: 1, text: 'MYR', flag: 'my'},
                {id: 2, text: 'SGD', flag: 'sg'},
            ]
        },
        itemType(){
            return[
                {id: 'service', text: this.$i18n.t('subMenu.salon_menu_service')},
                {id: 'product', text: this.$i18n.t('subMenu.salon_menu_product')},
            ]
        },
        additionalCharges(){
            return[
                {id: 'no', text: this.$i18n.t('label.no', {'item' : this.$i18n.t('label.additional_charges')})},
                {id: 'shipping', text: this.$i18n.t('tukang.shipping')},
                {id: 'door', text: this.$i18n.t('tukang.door_delivery')},
            ]
        },
        filteredAdditionalCharges(){
            var tempArr = JSON.parse(JSON.stringify(this.additionalCharges))
            var arr = this.selectedAdditionalCharges1.id != 'no' ? tempArr.filter(obj=> obj.id != this.selectedAdditionalCharges1.id) : tempArr
            
            return arr
        },
        tax(){
            return[
                {id: 'no', text: this.$i18n.t('salon_report.tax.no_tax'),},
                {id: 'gst', text: 'GST'},
                {id: 'sst', text: 'SST'},
            ]
        },
    },
    methods:{
        getImage(img){
            return img
        },
        priceValidation(id){
            var price = 0
            if(id == 'price'){
                price = this.price
            }else if(id == 'discount'){
                price = this.discount
            }else{
                price = this.discountAmount
            }
            var item = id == 'discount' ? this.$i18n.t('subMenu.salon_menu_discount') : this.$i18n.t(`label.${id}`) 
            var err = parseFloat(price) > 999.99 ? this.$i18n.t('message.error.price_long', {'item': item}) : null
           document.getElementById('err' + id).innerHTML = err == null ? null : err
        },
        inputTimePicker(e){
            if(e.H == "" && e.mm == ""){
                this.duration = {
                "H": "0",
                "mm": "15",
                }
            }
        },
        setTimePicker(e){
           if(e.data.H != "0"){
               this.minRange = []
               for(var i=0; i<4; i++){
                   this.minRange.push(i*15)
               }
           }else{
                this.minRange = []
                for(var j=1; j<4; j++){
                    this.minRange.push(j*15)
                }
           }
        },
        closeModal(isError){
            if(!isError){
                if(this.uploadToggle || this.$refs.deleteModal.toggleModal){
                    this.uploadToggle = false
                    this.$refs.deleteModal.toggleModal = false
                    this.resetImage()
                }else{
                    this.$emit('returnPostList')
                    this.$store.commit('RESET_TUKANG_IMAGE', 'post');
                } 
                
            }
            this.$parent.$parent.$parent.isModalShow = false
        },
        resetImage(){
            var image = this.$store.state.stateTukangPostImage.filter(i=> i.imageID === this.selectedImage.id)
            const found = this.gallery.some(o=> o.id == this.selectedImage.id)
            if(found){
                this.gallery = this.gallery.filter(j=> j.id !== this.selectedImage.id)
            }
            this.gallery.push({
                index: parseInt(image[0].imageID.substr(image[0].imageID.length - 1)),
                id: image[0].imageID,
                src: image[0].path,
                thumbnail: image[0].path
            })
            this.gallery.sort((a,b)=> a.index - b.index);
        },
        isNumber(e){
            return isNumber(e);
        },
        formatPrice(price){
            return formatPrice(price);
        },
        formFormatTime(num){
            return formFormatTime(num); 
        },
        getCategoryText(id){
            var text = ""
            for(var i=0; i<this.postType.length; i++){
                var type = this.postType[i].type
                for(var j=0; j<type.length; j++){
                    if(id == type[j].id){
                        text = type[j].text
                        break;
                    }
                }
            }
            return text
        },
        selectItemType(item){
            this.selectedItemType = item
            this.requiredAddress = this.selectedItemType.id == 'product' ? 1 : 0
        },
        selectAdditionalCharges(item, id){
            if(id == 'additional_1'){
                this.selectedAdditionalCharges1 = item
                this.selectedAdditionalCharges2 = this.filteredAdditionalCharges[0]
            }else{
                this.selectedAdditionalCharges2 = item
            }

        },
        selectCurrency(item){
            this.selectedCurrency = item
        },
        selectType(item){
            this.selectedPostType = item
        },
        selectTax(item){
            this.selectedTax = item
        },
        async editPost(item, isEdit){
            await this.getStaffList()

            this.isEdit = isEdit
            this.gallery = []
            this.companyName = item.TkCompanyName
            if(this.isEdit){
                this.postID = item.TkPostID
                this.stylistID = item.TkStylistID
                this.stylistName = item.TkStylistName
                this.name = item.TkPostName
                this.details = item.TkPostDetails
                this.price = item.TkPostPrice
                this.discount = item.TkPostDiscount
                this.duration = formFormatTime(parseInt(item.TkPostDuration));
                this.selectedPostType = {id: parseInt(item.TkPostTypeID), text: this.getCategoryText(parseInt(item.TkPostTypeID))}
                this.walkin = item.TkWalkInOnly
                this.memberOnly = item.TkMemberOnly
                this.selectedCurrency = JSON.parse(JSON.stringify(this.currency)).filter(obj => obj.id == item.DfCurrencyID)[0]
                this.gallery = item.TkPostImage
                this.discountCode = item.TkPostDiscountCode
                this.discountAmount = item.TkPostDiscountCodeAmt
                this.selectedTax = item.TkTaxName == '' ? this.tax[0] : this.tax.filter(obj=> obj.text == item.TkTaxName)[0]
                this.taxAmount = item.TkTaxAmt
                this.selectedAdditionalCharges1 = item.TkVariant1Name == '' ? this.additionalCharges[0] : this.additionalCharges.filter(obj=> obj.text == item.TkVariant1Name)[0]
                this.selectedAdditionalCharges2 = item.TkVariant2Name == '' ? this.additionalCharges[0] : this.additionalCharges.filter(obj=> obj.text == item.TkVariant2Name)[0]
                this.additionalCharges1 = item.TkVariant1Amt
                this.additionalCharges2 = item.TkVariant2Amt
                this.requiredAddress = item.TkReqAddr

                this.postURL = item.TkPostIdentifier

                var selectedItemType = item.TkReqAddr == 1 ? 'product' : 'service'
                this.selectedItemType = this.itemType.filter(obj=> obj.id == selectedItemType)[0]

                for(var i=1; i<=6; i++){
                    var key = "TkPostImage" + i;
                    if(!(this.gallery.some(el => el.id === key))){
                        this.gallery.push({
                            index: i,
                            id: key,
                            src: "",
                            thumbnail: ""
                        })
                    }
                }
            }else{
                this.postID = 0
                this.name = this.details = ""
                this.duration = {
                    "H": "0",
                    "mm": "15",
                    }
                this.price = this.discount = 0
                this.selectedPostType = this.postType[0].type[0]
                this.gallery = []
                this.selectedCurrency = this.currency[0]
                this.selectedTax = this.tax[0]
                this.discountCode = ""
                this.discountAmount = 0
                this.selectedAdditionalCharges1 = this.additionalCharges[0]
                this.selectedAdditionalCharges2 = this.filteredAdditionalCharges[0]
                this.additionalCharges1 = 0
                this.additionalCharges2 = 0
                this.taxAmount = 0
                this.requiredAddress = 0
                this.selectedItemType = this.itemType[0]
                this.postURL = ""
                this.walkin = 0
                this.memberOnly = 0
                this.setGallery();
            }
            this.$parent.toggleModal = true
        },
        setGallery(){
            for(var j=1; j<=6; j++){
                var key = "TkPostImage" + j
                this.gallery.push({
                    index: j,
                    id: key,
                    src: "",
                    thumbnail: "",
                })
            }
        },
        showDeleteImage(item){
            this.selectedImage = item
            var title = this.$i18n.t('header.delete_image')
            var message = this.$i18n.t('message.confirmation.delete_image')
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteImage(){
            var obj = {
                imageID: this.selectedImage.id,
                path: ""
            }
            this.$store.commit('SET_TUKANG_POST_IMAGE', obj);
            var data = {}
            data[this.selectedImage.id] = ""
            // var gallery = JSON.parse(JSON.stringify(this.gallery)).find(obj=> obj.id == this.selectedImage.id)


            var  gallery = this.gallery.map(obj =>
            obj.id === this.selectedImage.id
                ? { ...obj, src: '', thumbnail: '' }
                : obj
            );
            this.gallery = gallery
            this.$parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.success.delete_image'));
            // this.submitPostForm(data, false, true)
        },
        showUploadImage(item){
            this.selectedImage = item
            this.uploadToggle = true
        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.upload'));
            }else{
               this.$parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.success.upload'));

                var obj = {
                    imageID: this.selectedImage.id,
                    path: response.path
                }
                this.$store.commit('SET_TUKANG_POST_IMAGE', obj);
            }
            this.$refs.dropzone.removeFile(file)
        },
        submitFormData(){
            if(this.selectedTax.id == 'no'){
                this.taxAmount = 0
            }
            if(this.selectedAdditionalCharges1.id == 'no'){
                this.additionalCharges1 = 0
            }
            if(this.selectedAdditionalCharges2.id == 'no'){
                this.additionalCharges2 = 0
            }

            var isValidate = this.formValidation()
            if(isValidate){
                var data = this.setFormData()
                var stateImage = JSON.parse(JSON.stringify(this.gallery))

                for(var i=0; i<stateImage.length; i++){
                    data[stateImage[i].id] = stateImage[i].src
                }
                this.submitPostForm(data, true, false)
            }
        },
        formValidation(){
            var validate = true
            var grandTotal = (parseFloat(this.price) - parseFloat(this.discount)) + (parseFloat(this.taxAmount) + parseFloat(this.additionalCharges1) + parseFloat(this.additionalCharges2)) - (this.discountCode == '' ? 0 : parseFloat(this.discountAmount)) 

            if(parseFloat(this.price) > 999.99){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.price_long', {'item': this.$i18n.t('label.price')}));
                validate = false
            }else if(parseFloat(this.discount) > 999.99){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.price_long', {'item': this.$i18n.t('subMenu.salon_menu_discount')}));
                validate = false
            }else if(this.discountCode != '' && this.discountAmount == ''){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.required', {'item': this.$i18n.t('label.discount_amount')}));
                validate = false
            }else if(parseFloat(this.discountAmount) > 999.99){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.price_long', {'item': this.$i18n.t('label.discount_amount')}));
                validate = false
            }else if(this.selectedTax.id != 'no' && this.taxAmount == ''){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.required', {'item': this.selectedTax.text}));
                validate = false
            }else if(this.selectedAdditionalCharges1.id != 'no' && this.additionalCharges1 == ''){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.required', {'item': this.selectedAdditionalCharges1.text}));
                validate = false
            }else if(this.selectedAdditionalCharges2.id != 'no' && this.additionalCharges2 == ''){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.required', {'item': this.selectedAdditionalCharges2.text}));
                validate = false
            }else if(parseFloat(grandTotal) <= 4.00){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.price_short', {'item': this.$i18n.t('label.price_after') + ' [' +this.selectedCurrency.text + ' ' + parseFloat(grandTotal).toFixed(2) +'] ' }));
                validate = false
            }else if(this.duration.H == "0" && this.duration.mm == "00"){
                document.getElementById('err').innerHTML = this.$i18n.t('message.error.duration');
                validate = false
            }

            return validate
        },
        setFormData(){
            var duration = this.duration.H + " hr " + this.duration.mm + " Min"
            var data = {
                TkPostName: this.name,
                TkPostDetails: this.details,
                TkPostPrice: this.price,
                TkPostDiscount: this.discount,
                TkPostDiscountCode: this.discountCode,
                TkPostDiscountCodeAmt: this.discountAmount,
                TkPostDuration: convertToMin(duration),
                TkPostTypeID: this.selectedPostType.id,
                TkMemberOnly: this.memberOnly ? 1 : 0,
                TkWalkInOnly: this.walkin ? 1 : 0,
                DfCurrencyID: this.selectedCurrency.id, 
                TkTaxName: this.selectedTax.id == 'no' ? '' : this.selectedTax.text,
                TkTaxAmt: this.selectedTax.id == 'no' ? 0 : this.taxAmount,
                TkVariant1Name: this.selectedAdditionalCharges1.id == 'no' ? '' : this.selectedAdditionalCharges1.text,
                TkVariant1Amt: this.selectedAdditionalCharges1.id == 'no' ? 0 : this.additionalCharges1,
                TkVariant2Name: this.selectedAdditionalCharges2.id == 'no' ? '' : this.selectedAdditionalCharges2.text,
                TkVariant2Amt: this.selectedAdditionalCharges2.id == 'no' ? 0 : this.additionalCharges2,
                TkReqAddr: this.requiredAddress ? 1 : 0,
                TkPostUrl: this.$api.URL_TUKANG + this.shopName + '/' + this.postURL,
                TkPostIdentifier: this.postURL
            }
            if(!this.isEdit){
                data.TkStylistID = this.selectedStaff.TkStylistID
            }
            return data
        },
        async submitPostForm(data, isFormData, isDeleteImage){
            const url = this.isEdit ?  this.$api.TUKANG_ALL_POST + "/" + this.postID + this.$api.UPDATE : this.$api.TUKANG_ALL_POST

            let $vm = this
            var isSubmitPostSuccess = false
            await $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    isSubmitPostSuccess = true

                    var message = $vm.$i18n.t('subMenu.my_salon_tukang') + $vm.$i18n.t('header.post') + $vm.$i18n.t('message.success.success', {'action': $vm.isEdit ? $vm.$i18n.t('message.success.action.update') :  $vm.$i18n.t('message.success.action.add') })
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
        },
        selectStaff(item){
            this.selectedStaff = item
        },
        async getStaffList(){
            this.staffs = []
            let $vm = this;
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: $vm.$api.TUKANG_SHOP + $vm.$api.TUKANG_STAFF,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            var items = [];
            for(var i=0; i<result.length; i++){

                items.push({
                    staffID: result[i].staffID,
                    outletID: result[i].outletID,
                    TkStylistID: result[i].TkStylistID,
                    TkStylistName: result[i].TkStylistName == "" ? "-" :  result[i].TkStylistName,
                })
            }
            this.staffs = items
            this.selectedStaff = this.staffs[0]
        },
    },
    async mounted(){
        let $vm = this
        $vm.shopName = $vm.$store.state.shopName.split(' ').join('')
        await $vm.getStaffList()

        $vm.duration = {
        "H": "0",
        "mm": "15",
        }

        for(var i=1; i<4; i++){
            $vm.minRange.push(i*15);
        }
        for(var j=0; j<10; j++){
            $vm.hourRange.push(j);
        }
        $vm.setGallery()
        $vm.selectedItemType = $vm.itemType[0]
    },
}
</script>
<style scoped>
.card-columns{
    column-count: 2 !important;
    column-gap: 1em;
}
.card-header{
    background: #F2F0F7;
}
.show{
    display: block;
}
.img-item{
    width: 15em;
}
.icon-stack-1x{
    top: 30%;
    left: 50%;
    font-size: .35em;
}
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>